import type { StaticLandingPage } from '../../../content';
import audienceTrainingSession from './assets/audience-training-session.jpg';
import heroSustainability from './assets/cover-masterclass-sustainability.jpg';
import audienceChangeRoleIcon from './assets/icons/audience-change-role.png';
import audienceConsultingIcon from './assets/icons/audience-consulting.png';
import audiencePrerequisitesIcon from './assets/icons/audience-prerequisites.png';
import audienceQualificationIcon from './assets/icons/audience-qualification.png';
import photoNicolettaFerriani from './assets/photo-nicoletta-ferriani.jpg';
import photoSilviaArchetti from './assets/photo-silvia-archetti.jpg';
import photoValentinaRomagnoli from './assets/photo-valentina-romagnoli.jpg';
// Placeholder PDF (copied from India LP) — replace with the Italian brochure later
import brochurePlaceholder from './assets/downloads/Advanced_Certificate_in_Cyber_Security_ACCS_Career_Path_2pgs_SA.pdf';

export const academyItPage = {
  slug: 'aca-it-sustainability',
  archetype: 'lead-gen',
  body: [
    {
      _uid: 'it-sustainability-hero',
      title: 'Masterclass per Sustainability Managers e Practitioners',
      variant: 'lead',
      subtitle: 'Percorso di Formazione e Certificazione di Persone',
      component: 'hero_section',
      hero_image: {
        alt: 'Cover della Masterclass Sustainability di TÜV Italia Akademie',
        filename: heroSustainability,
      },
      hero_stats: [],
      highlights: [
        {
          _uid: 'it-sustainability-highlight-1',
          icon: 'schedule',
          title: '5 Moduli',
          component: 'icon_text_item',
        },
        {
          _uid: 'it-sustainability-highlight-2',
          icon: 'workspace_premium',
          title: 'Certificazione TÜV SÜD',
          component: 'icon_text_item',
        },
        {
          _uid: 'it-sustainability-highlight-3',
          icon: 'groups',
          title: 'Docenti Esperti',
          component: 'icon_text_item',
        },
        {
          _uid: 'it-sustainability-highlight-4',
          icon: 'verified',
          title: 'Globalmente riconosciuta',
          component: 'icon_text_item',
        },
      ],
      description:
        "Iscriviti al percorso di formazione per diventare Manager della sostenibilità. Una Masterclass completa, innovativa e flessibile, qualificata per il riconoscimento di 40 crediti formativi necessari per accedere all'esame di certificazione dei profili professionali Sustainability Manager e Practitioner in conformità con la prassi UNI/PdR 109.1:2021.",
      badge_1_text: 'Nuova Edizione Disponibile',
      badge_2_text: 'Certificazione TÜV SÜD',
      academy_label: 'TÜV Italia Akademie',
      nav_cta_label: 'Chiedi maggiori informazioni',
      hero_image_alt: 'Cover della Masterclass Sustainability di TÜV Italia Akademie',
      primary_cta_label: 'Scarica la Brochure',
      secondary_cta_label: 'Chiedi maggiori informazioni',
    },
    {
      _uid: 'it-sustainability-trust',
      label: 'Garanzia, Valore e Fiducia TÜV SÜD',
      partners: [],
      component: 'trust_bar_section',
    },
    {
      _uid: 'it-sustainability-benefits',
      title: 'Investi nella Certificazione',
      eyebrow: 'Perché diventare Sustainability Manager',
      benefits: [
        {
          _uid: 'it-sustainability-benefit-1',
          icon: 'trending_up',
          title: 'Una professione in forte crescita',
          component: 'icon_text_item',
          description:
            'Negli ultimi anni il ruolo del Sustainability Manager è diventato centrale nelle strategie aziendali, aprendo opportunità concrete di carriera in organizzazioni di ogni settore e dimensione.',
        },
        {
          _uid: 'it-sustainability-benefit-2',
          icon: 'leaderboard',
          title: 'Da esperto tecnico a leader strategico',
          component: 'icon_text_item',
          description:
            'Il Sustainability Manager di oggi non è solo un esperto ambientale, ma una figura chiave capace di guidare il cambiamento e influenzare le decisioni strategiche dell’azienda.',
        },
        {
          _uid: 'it-sustainability-benefit-3',
          icon: 'workspace_premium',
          title: 'Competenze complete e certificate',
          component: 'icon_text_item',
          description:
            'La Masterclass offre un percorso strutturato di formazione e certificazione, sviluppando competenze tecniche, relazionali e comportamentali indispensabili per il ruolo.',
        },
        {
          _uid: 'it-sustainability-benefit-4',
          icon: 'task_alt',
          title: 'Preparazione concreta alle sfide aziendali',
          component: 'icon_text_item',
          description:
            'Acquisirai un bagaglio di conoscenze coerente e applicabile, pensato per affrontare con efficacia la trasformazione sostenibile che coinvolge tutte le funzioni aziendali.',
        },
        {
          _uid: 'it-sustainability-benefit-5',
          icon: 'diversity_3',
          title: 'Leadership e decisioni etiche',
          component: 'icon_text_item',
          description:
            'Imparerai a rafforzare le tue capacità di leadership e gestione, prendendo decisioni strategiche vantaggiose e adottando processi orientati all’etica e alla responsabilità.',
        },
        {
          _uid: 'it-sustainability-benefit-6',
          icon: 'eco',
          title: 'Sostenibilità integrata nel business',
          component: 'icon_text_item',
          description:
            'Sarai in grado di integrare i principi della sostenibilità nei processi aziendali, contribuendo allo sviluppo di modelli di business sostenibili, innovativi ed efficienti.',
        },
      ],
      component: 'benefits_section',
      description:
        'Il percorso di formazione e certificazione per Sustainability Manager o Practitioner ti fornisce le competenze manageriali in ambito Sostenibilità e le valida per farti riconoscere sul mercato.',
    },
    {
      _uid: 'it-sustainability-stats',
      variant: 'feature-cards',
      stats: [
        {
          _uid: 'it-sustainability-stat-1',
          icon: 'school',
          title: '70 ore di formazione in modalità blended',
          description:
            '35h in modalità e-learning (di cui 8h opzionali) di auto-apprendimento secondo le proprie esigenze + 30h di sessioni in presenza con i docenti, per applicare immediatamente le conoscenze acquisite nei workshop di gruppo.',
          component: 'stat_item',
        },
        {
          _uid: 'it-sustainability-stat-2',
          icon: 'groups',
          title: 'Partecipazione attiva alla community della masterclass',
          description:
            'Partecipazione ad un ambiente interattivo per favorire lo scambio di idee, discussioni, condivisione di aggiornamenti e soprattutto per costruire connessioni significative nel proprio settore, amplificando la learning experience e creando un network professionale.',
          component: 'stat_item',
        },
        {
          _uid: 'it-sustainability-stat-3',
          icon: 'forum',
          title: 'Incontri con esperti e manager del settore',
          description:
            '5 incontri di Q&A con esperti e manager coinvolti in progetti di sostenibilità, in cui saranno condivisi Case Studies per offrire ai partecipanti un accesso diretto a conoscenze specializzate.',
          component: 'stat_item',
        },
        {
          _uid: 'it-sustainability-stat-4',
          icon: 'workspace_premium',
          title: 'Esame accreditato e certificazione professionale',
          description:
            'La Masterclass, in accordo con la UNI/PdR 109-1:2021, risponde ai requisiti di accesso dell’esame per la certificazione delle figure professionali, come riconoscimento ufficiale delle capacità acquisite spendibili sul mercato del lavoro.',
          component: 'stat_item',
        },
      ],
      cta_text: "Scopri com'è composta la Masterclass",
      cta_subtitle: 'Inizia il tuo percorso',
      component: 'stats_section',
      cta_label: 'Richiedi informazioni ora',
    },
    {
      _uid: 'it-sustainability-modules',
      title: '5 Moduli Formativi + Certificazione',
      eyebrow: 'Il Percorso',
      module_label: 'Modulo',
      modules: [
        {
          _uid: 'it-sustainability-module-1',
          icon: 'lan',
          type: 'Modulo',
          title: 'Business model sostenibile e basato su prodotti/servizi con impatti positivi',
          number: '01',
          duration: '8 corsi e-learning + 1 workshop + 1 sessione di Q&A',
          component: 'module_item',
          description:
            'Amplia la tua visione del ruolo del Sustainability Manager e Practitioner, approfondendo il sistema economico e le interazioni con i sistemi aziendali, sociali e ambientali che lo circondano.',
        },
        {
          _uid: 'it-sustainability-module-2',
          icon: 'code',
          type: 'Modulo',
          title: 'Sviluppo strategico degli impatti e rischi ambientali e sociali della value chain',
          number: '02',
          duration: '5 corsi e-learning + 1 workshop + 1 sessione di Q&A',
          component: 'module_item',
          description:
            'Acquisisci gli elementi di conoscenza necessari a valutare gli impatti e rischi della value chain e sviluppare strategicamente la filiera del valore.',
        },
        {
          _uid: 'it-sustainability-module-3',
          icon: 'warning',
          type: 'Modulo',
          title: 'Sviluppo strategico di processi decisionali (Governance) eticamente orientati',
          number: '03',
          duration: '8 corsi e-learning + 1 workshop + 1 sessione di Q&A',
          component: 'module_item',
          description:
            'Amplia le tue conoscenze per orientare processi decisionali eticamente orientati, e cioè dare vita e corpo a una governance sostenibile.',
        },
        {
          _uid: 'it-sustainability-module-4',
          icon: 'cloud',
          type: 'Modulo',
          title: 'Leadership, sviluppo di vision, mission e purpose allineati alla strategia dell’organizzazione',
          number: '04',
          duration: '5 corsi e-learning + 1 workshop + 1 sessione di Q&A',
          component: 'module_item',
          description:
            'Sviluppa le conoscenze necessarie per costruire la competenza necessaria a sostenere la leadership ESG dell’organizzazione.',
        },
        {
          _uid: 'it-sustainability-module-5',
          icon: 'smart_toy',
          type: 'Modulo',
          title: 'Gestione delle relazioni e Comunicazione con gli stakeholder',
          number: '05',
          duration: '6 corsi e-learning + 1 workshop + 1 sessione di Q&A',
          component: 'module_item',
          description:
            'Sviluppa le competenze necessarie per gestire le relazioni e la comunicazione basata sulla responsabilità con gli stakeholder.',
        },
        {
          _uid: 'it-sustainability-module-6',
          icon: 'policy',
          type: 'Certificazione',
          title: 'Certificazione di persone per le figure professionali Sustainability Manager e Practitioner',
          heading: 'Certificazione di persone per le figure professionali Sustainability Manager e Practitioner',
          number: '',
          duration: 'Presentazione della candidatura + Esame + Rilascio della Certificazione',
          component: 'module_item',
          description:
            'La partecipazione alla Masterclass ti da la possibilità di accedere all’esame di certificazione in accordo alla norma UNI/PdR 109-1:2021.',
        },
      ],
      footnote: '',
      component: 'modules_section',
      cta_label: 'Richiedi informazioni sul Percorso Completo',
      description: '',
    },
    {
      _uid: 'it-sustainability-audience',
      image: {
        alt: 'Sessione di formazione in aula',
        filename: audienceTrainingSession,
      },
      title: 'A chi è rivolta la Masterclass?',
      eyebrow: 'Target di riferimento',
      audiences: [
        {
          _uid: 'it-sustainability-audience-1',
          icon: 'change_circle',
          icon_image: {
            alt: 'Icona cambio di ruolo',
            filename: audienceChangeRoleIcon,
          },
          title: 'Sta affrontando un cambio di ruolo o di impiego',
          component: 'icon_text_item',
          description:
            'Professionisti che si trovano in una fase di transizione professionale e desiderano riqualificarsi in un ambito ad alta crescita e rilevanza strategica.',
        },
        {
          _uid: 'it-sustainability-audience-2',
          icon: 'business_center',
          icon_image: {
            alt: 'Icona consulenza',
            filename: audienceConsultingIcon,
          },
          title: 'Opera nel mondo della consulenza',
          component: 'icon_text_item',
          description:
            'Consulenti che vogliono rafforzare le proprie competenze in ambito sostenibilità ed ESG per supportare efficacemente le organizzazioni nei percorsi di trasformazione.',
        },
        {
          _uid: 'it-sustainability-audience-3',
          icon: 'workspace_premium',
          icon_image: {
            alt: 'Icona qualificazione professionale',
            filename: audienceQualificationIcon,
          },
          title: 'Vuole qualificarsi professionalmente',
          component: 'icon_text_item',
          description:
            'Persone che intendono acquisire competenze strutturate e riconosciute, anche in assenza dei requisiti formativi necessari per accedere immediatamente alla certificazione.',
        },
        {
          _uid: 'it-sustainability-audience-4',
          icon: 'fact_check',
          icon_image: {
            alt: 'Icona prerequisiti di accesso',
            filename: audiencePrerequisitesIcon,
          },
          title: 'Prerequisiti di accesso',
          component: 'icon_text_item',
          description:
            'Nessun prerequisito è richiesto per partecipare al percorso formativo della Masterclass. Prerequisiti specifici sono richiesti esclusivamente per l’accesso all’esame di certificazione.',
        },
      ],
      component: 'audience_section',
      cta_label: 'Verifica i requisiti e richiedi  informazioni',
      image_alt: 'Sessione di formazione in aula',
      description:
        'La Masterclass è rivolta a professionisti che desiderano sviluppare una visione sistemica della sostenibilità e acquisire strumenti strategici e operativi per integrare i criteri ESG nei processi aziendali, contribuendo attivamente all’evoluzione verso modelli di business più responsabili, innovativi e orientati al lungo periodo. In particolare, il percorso è pensato per chi:',
    },
    {
      _uid: 'it-sustainability-trainers',
      title: 'Affidati e fatti guidare da noi',
      eyebrow: 'Un team al tuo supporto',
      trainers: [
        {
          _uid: 'it-sustainability-trainer-3',
          name: 'Nicoletta Ferriani',
          image: {
            alt: 'Nicoletta Ferriani',
            filename: photoNicolettaFerriani,
          },
          title: 'Esperta di Formazione',
          component: 'trainer_item',
          experience: 'Formazione',
          certifications: [],
          specialization: 'Supporta i partecipanti nell’orientamento e nella valorizzazione del percorso formativo.',
        },
        {
          _uid: 'it-sustainability-trainer-1',
          name: 'Silvia Archetti',
          image: {
            alt: 'Silvia Archetti',
            filename: photoSilviaArchetti,
          },
          title: 'Referente della Certificazione',
          component: 'trainer_item',
          experience: 'Certificazione',
          certifications: [],
          specialization: 'Guida i partecipanti nella comprensione dei requisiti e del valore della certificazione.',
        },
        {
          _uid: 'it-sustainability-trainer-2',
          name: 'Valentina Romagnoli',
          image: {
            alt: 'Valentina Romagnoli',
            filename: photoValentinaRomagnoli,
          },
          title: 'Tutor della Masterclass',
          component: 'trainer_item',
          experience: 'Tutor',
          certifications: [],
          specialization:
            'Accompagna i partecipanti lungo tutto il percorso, offrendo supporto continuo e un punto di contatto dedicato.',
        },
      ],
      component: 'trainers_section',
      description:
        'Dalla progettazione formativa alla certificazione, fino al supporto continuo, la Masterclass è seguita da tre figure esperte TÜV Italia che accompagnano i partecipanti in ogni fase del percorso.',
    },
    {
      _uid: 'it-sustainability-testimonials',
      title: 'Cosa dicono i partecipanti',
      eyebrow: 'Testimonianze',
      variant: 'lead',
      show_images: false,
      component: 'testimonials_section',
      description: 'Storie di successo dai nostri partecipanti.',
      testimonials: [
        {
          _uid: 'it-sustainability-testimonial-1',
          name: 'Alessio C.',
          role: 'General Manager',
          quote:
            'Ho trovato persone che mi hanno trasmesso passione, motivi di riflessione e confronto. È stata una prima esperienza per tutti, siamo stati dei pionieri. Personalmente avevo qualche dubbio nell’intraprendere questo percorso, ma in seguito ho trovato il mio nuovo scopo.',
          rating: 5,
          initials: 'AC',
          component: 'testimonial_item',
        },
        {
          _uid: 'it-sustainability-testimonial-2',
          name: 'Simona B.',
          role: 'Sustainability Compliance Specialist',
          quote:
            "Ho apprezzato molto gli incontri di persona, che ci permettono di lavorare e approfondire le nostre soft skills, così come i workshop con gli esperti, che hanno lasciato il segno dell'innovazione e ci hanno dato un valore aggiunto durante il percorso. Si è instaurata molta sintonia con gli altri partecipanti che hanno background eterogenei.",
          rating: 5,
          initials: 'SB',
          component: 'testimonial_item',
        },
        {
          _uid: 'it-sustainability-testimonial-3',
          name: 'Laura S.',
          role: 'Legal & Sustainability Specialist',
          quote:
            'Il corso è stato altamente interessante e ricco di contenuti inerenti al tema della Masterclass. Nonostante io lavori nel campo della sostenibilità da tanti anni, ho imparato davvero molto e arricchito il mio bagaglio culturale. Ho ritenuto gli incontri in presenza interessanti e ricchi di contenuti.',
          rating: 5,
          initials: 'LS',
          component: 'testimonial_item',
        },
      ],
    },
    {
      _uid: 'it-sustainability-form',
      title: 'Scarica la Brochure & Mettiti in Contatto con noi',
      eyebrow: 'Informati oggi',
      component: 'form_section',
      form_title: 'Richiedi Informazioni ora!',
      legal_text:
        'Inviando il modulo, autorizzi TÜV Italia a trattare i tuoi dati secondo la privacy policy applicabile.',
      trust_text: 'Riceverai solo comunicazioni in merito alla masterclass.',
      description:
        'Inserisci i tuoi dettagli e le nostre esperte si metteranno in contatto con te per rispondere a domande o dubbi, supportarti sulla scelta e illustrarti le opportunità.',
      trust_title: 'Le tue informazioni sono al sicuro!',
      consent_text: 'Acconsento a essere contattato da TÜV Italia Akademie in merito alla Masterclass Sustainability.',
      submit_label: 'Scarica la Brochure',
      success_text:
        'Grazie per la richiesta. Puoi scaricare la brochure qui sotto. Il team TÜV Italia Akademie ti contatterà a breve con i dettagli della Masterclass e il calendario.',
      // Placeholder PDF — replace the file in assets/downloads/ and the label below
      success_downloads: [{ label: 'Brochure Masterclass (PDF)', url: brochurePlaceholder }],
      value_points: [
        {
          _uid: 'it-sustainability-form-point-1',
          icon: 'description',
          title: 'Ricevi la brochure completa con tutti i dettagli',
          component: 'icon_text_item',
        },
        {
          _uid: 'it-sustainability-form-point-2',
          icon: 'calendar_month',
          title: 'Scopri quando sono previste le prossime edizioni e i calendari',
          component: 'icon_text_item',
        },
        {
          _uid: 'it-sustainability-form-point-3',
          icon: 'local_offer',
          title: 'Accedi all’esclusiva promozione dedicata',
          component: 'icon_text_item',
        },
        {
          _uid: 'it-sustainability-form-point-4',
          icon: 'support_agent',
          title: 'Richiedi una sessione di consulenza privata',
          component: 'icon_text_item',
        },
        {
          _uid: 'it-sustainability-form-point-5',
          icon: 'corporate_fare',
          title: 'Informati sulle opportunità di partecipazione multipla in azienda',
          component: 'icon_text_item',
        },
      ],
      success_title: 'Grazie per il tuo interesse!',
      success_button_label: 'Invia una nuova richiesta',
      first_name_label: 'Nome',
      first_name_placeholder: 'Inserisci il tuo nome',
      last_name_label: 'Cognome',
      last_name_placeholder: 'Inserisci il tuo cognome',
      email_label: 'Indirizzo E-mail',
      email_placeholder: 'nome.cognome@azienda.it',
      phone_label: 'Numero di Telefono',
      phone_placeholder: '+39 XXX XXXXXXX',
      company_label: 'Azienda / Organizzazione',
      company_placeholder: 'Inserisci il nome della tua azienda',
      designation_label: 'Ruolo lavorativo',
      designation_placeholder: 'Inserisci la tua posizione lavorativa',
      interest_label: 'Il tuo interesse',
      interest_placeholder: 'A cosa sei interessato?',
      interest_options: [
        {
          _uid: 'it-sustainability-interest-1',
          label: 'Solo Percorso Formativo',
          value: 'solo-percorso-formativo',
          component: 'select_option_item',
        },
        {
          _uid: 'it-sustainability-interest-2',
          label: 'Solo Certificazione di Persone',
          value: 'solo-certificazione',
          component: 'select_option_item',
        },
        {
          _uid: 'it-sustainability-interest-3',
          label: 'Formazione + Certificazione',
          value: 'formazione-certificazione',
          component: 'select_option_item',
        },
      ],
    },
    {
      _uid: 'it-sustainability-faq',
      faqs: [
        {
          _uid: 'it-sustainability-faq-1',
          question: 'Perché partecipare alla Masterclass?',
          answer_blocks: [
            {
              type: 'paragraph',
              text: "Studia seguendo un approccio formativo integrato e flessibile: il percorso crea un ambiente dinamico in cui la teoria si fonde con l'applicazione pratica, massimizzando il valore del tuo apprendimento. Inoltre, l’integrazione tra metodologie online e in presenza ti garantisce la possibilità di personalizzare il percorso, consentendoti di adattare lo studio alle tue esigenze lavorative e di vita.",
            },
            {
              type: 'paragraph',
              text: 'Ottieni delle competenze avanzate e specifiche: il percorso ti fornisce le competenze tecniche e non-tecniche necessarie per ideare e sviluppare un business model sostenibile, oltre a presentarti le azioni di marketing e comunicazione necessarie.',
            },
            {
              type: 'paragraph',
              text: 'Diventa una figura professionale del futuro: sarai in grado di guidare le organizzazioni verso la conformità normativa e applicare una leadership innovativa nel perseguire obiettivi sostenibili. Le imprese proattive nella sostenibilità, infatti, avranno un vantaggio competitivo a livello globale, guadagnando visibilità nella filiera e contribuendo al benessere delle comunità e alla sostenibilità economica a lungo termine.',
            },
            {
              type: 'paragraph',
              text: 'Consegui la certificazione: il percorso è progettato per fornirti una formazione avanzata e specializzata in conformità con lo standard UNI/PdR 109-1:2021 ed è riconosciuto da TÜV Examination Institute come percorso preparatorio all’esame di certificazione del personale.',
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'it-sustainability-faq-2',
          question: 'Quali sono i benefici per i partecipanti?',
          answer_blocks: [
            {
              type: 'paragraph',
              text: 'Migliora le tue opportunità di carriera: la certificazione delle competenze funge da riconoscimento ufficiale delle capacità acquisite, migliorando le tue prospettive di carriera e rendendo il tuo profilo più appetibile per ogni opportunità lavorativa nel settore della sostenibilità.',
            },
            {
              type: 'paragraph',
              text: 'Contribuisci alla sostenibilità aziendale: sarai in grado di applicare le conoscenze acquisite per aiutare le aziende a sviluppare strategie più sostenibili, migliorando le prestazioni ambientali, sociali ed economiche delle organizzazioni.',
            },
            {
              type: 'paragraph',
              text: "Crea un network e nuove collaborazioni: durante il percorso, avrai l'opportunità di interagire con altri professionisti ed esperti del settore della sostenibilità, creando una rete di contatti e potenziali collaborazioni future.",
            },
            {
              type: 'paragraph',
              text: "Rimani aggiornato: la partecipazione a questo tipo di percorso ti consentirà di rimanere aggiornato sulle ultime tendenze, innovazioni e best practice nel campo della sostenibilità, garantendoti un'evoluzione costante delle tue competenze professionali.",
            },
            {
              type: 'paragraph',
              text: 'Certifica le tue competenze: al termine del percorso, avrai la possibilità di ottenere la certificazione delle competenze conforme alla UNI/PdR 109-1:2021, che attesta la tua conoscenza e competenza nel campo della gestione della sostenibilità.',
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'it-sustainability-faq-3',
          question: 'Quali sono gli obiettivi didattici?',
          answer_blocks: [
            {
              type: 'paragraph',
              text: 'Acquisisci competenze manageriali: migliora le tue capacità di leadership e gestione, applicando strumenti pratici per integrare efficacemente la sostenibilità nei processi aziendali.',
            },
            {
              type: 'paragraph',
              text: 'Sviluppa capacità decisionali: impara metodologie efficaci, che ti aiuteranno a prendere decisioni strategiche allineate con gli obiettivi di sostenibilità.',
            },
            {
              type: 'paragraph',
              text: 'Acquisisci competenze pratiche: avrai la possibilità di acquisire competenze pratiche attraverso analisi di case studies ed esercitazioni, per applicare direttamente ciò che hai imparato.',
            },
            {
              type: 'paragraph',
              text: 'Preparati per conseguire la Certificazione: apprenderai le conoscenze e la preparazione necessarie per sostenere l’esame e ottenere la certificazione in accordo alla UNI/PdR 109-1:2021.',
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'it-sustainability-faq-4',
          question: 'Quali sono le modalità di frequenza del corso?',
          answer_blocks: [
            {
              type: 'paragraph',
              text: 'Per completare il percorso di formazione e ricevere l’attestato di Frequenza, è necessario garantire almeno il 75% di partecipazione alle sessioni erogate in modalità sincrona (ovvero i Workshop in presenza e le sessioni Q&A online).',
            },
            {
              type: 'paragraph',
              text: 'Unita didattiche in modalità e-learning: queste unità didattiche potranno essere seguite dalla piattaforma online, in autonomia dal partecipante. L’importante sarà rispettare la scadenza entro cui queste saranno disponibili: ogni modulo prevede una finestra temporale di attivazione e chiusura (vedi Calendario all’interno della brochure informativa), entro la quale dovrai completare tutte le unità didattiche per arrivare preparato alle sessioni di Workshop in presenza.',
            },
            {
              type: 'paragraph',
              text: 'Classroom Training con Workshop in presenza: le lezioni in presenza avranno luogo nelle date prefissate (vedi Calendario), presso la sede TÜV Italia di Casalecchio di Reno (BO). Per una maggiore efficacia formativa e di apprendimento, ti consigliamo di frequentare tutti i Workshop in presenza, quale occasione per mettere in pratica le conoscenze apprese.',
            },
            {
              type: 'paragraph',
              text: 'Sessioni di Q&A: le sessioni Q&A saranno organizzate in modalità online, tramite la piattaforma Microsoft Teams. Anche la frequenza a queste sessioni è fortemente consigliata, in quanto avrai la possibilità di incontrare manager ed esperti coinvolti in progetti di sostenibilità, per accedere a conoscenze specializzate, condividere esperienze e fare domande.',
            },
            {
              type: 'paragraph',
              text: 'Social Learning all’interno della Community: durante tutta la partecipazione alla Masterclass, avrai la possibilità di far parte della community ed interagire all’interno della piattaforma digitale con gli esperti di contenuto docenti, il Tutor e gli altri partecipanti. All’interno di questa, potrai porre domande, scambiare idee e condividere contenuti.',
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'it-sustainability-faq-5',
          question: 'Quali sono i prerequisiti per accedere alla Masterclass?',
          answer_blocks: [
            {
              type: 'paragraph',
              text: 'Percorso di formazione: non ti è richiesto alcun prerequisito per partecipare al percorso di formazione della Masterclass.',
            },
            {
              type: 'paragraph',
              text: 'Certificazione per Sustainability Manager: per poter accedere e sostenere l’esame finale per la figura di Sustainability Manager è necessario che tu possegga i seguenti prerequisiti:',
            },
            {
              type: 'list',
              items: [
                'Diploma di scuola secondaria superiore',
                'Attività formativa di 40 ore negli ultimi 3 anni*',
                'Esperienza lavorativa specifica documentata di almeno 5 anni con incarichi di CSR Manager o Sustainability Practitioner, all’interno di aziende o società di consulenza, con la responsabilità gerarchica o funzionale di gestire risorse.',
                'In caso di possesso di Titolo Accademico (Laurea Triennale, Magistrale, Master di Primo o Secondo Livello) sono richiesti almeno 3 anni di esperienza continuativa specifica.',
              ],
            },
            {
              type: 'paragraph',
              text: 'Certificazione per Sustainability Practitioner: per poter accedere e sostenere l’esame finale per la figura di Sustainability Practitioner è necessario che tu possegga i seguenti prerequisiti:',
            },
            {
              type: 'list',
              items: [
                'Diploma di scuola secondaria superiore',
                'Attività formativa di 40 ore negli ultimi 3 anni*',
                'Esperienza lavorativa specifica documentata di almeno 3 anni con incarichi di Sustainability Practitioner',
                'In caso di possesso di un Titolo (Laurea, un Master o Corso di Alta Formazione specifici sui temi Sostenibilità) sono richiesti 2 anni di esperienza continuativa specifica.',
              ],
            },
            {
              type: 'paragraph',
              text: '*Come posso dimostrare di avere partecipato ad una formazione di 40 ore per rispondere alla richiesta di requisito? Puoi frequentare uno o più corsi per un totale di almeno 40 ore. Per ogni corso svolto è necessario fornire le seguenti informazioni:',
            },
            {
              type: 'list',
              items: [
                'attestato di partecipazione',
                'titolo del corso o dei corsi',
                'durata in ore',
                'argomenti trattati o locandina con dettaglio dell’attività formativa',
                'sito web dell’organizzatore del corso o dei corsi',
              ],
            },
            {
              type: 'paragraph',
              text: 'Ti informiamo che il percorso formativo proposto in questa pagina da TÜV Italia Akademie copre i requisiti richiesti. Per maggiori dettagli o dubbi riguardanti i prerequisiti della certificazione, puoi metterti in contatto con tuv.esami@tuvsud.com',
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'it-sustainability-faq-6',
          question: 'Come si svolgerà l’esame e la certificazione?',
          answer_blocks: [
            {
              type: 'paragraph',
              text: "L'iter di certificazione dei candidati si articola nei seguenti passaggi:",
            },
            {
              type: 'list',
              items: [
                'presentazione della candidatura e verifica del possesso dei requisiti di istruzione, formazione ed esperienza professionale richiesti dallo schema CSR (vedi FAQ precedente);',
                'svolgimento dell’esame di certificazione;',
                'rilascio della certificazione, dopo approvazione da parte del comitato di delibera.',
              ],
            },
            {
              type: 'paragraph',
              text: 'L’esame di certificazione, che svolgerai in modalità online, sarà composto da una prova scritta ed una orale della durata di circa 2 ore. La prova scritta sarà composta da un test di 30 domande a risposta multipla, mentre la prova orale avverrà tramite colloquio individuale in cui rivaluterai gli errori del test scritto, dovrai rispondere ad alcune domande aperte e discuterai un progetto di sostenibilità presentato in autonomia (il progetto verrà discusso solo in caso di esame per Sustainability Manager).',
            },
            {
              type: 'paragraph',
              text: "La soglia di superamento per entrambe le prove è pari al 70%. L'esame è superato se entrambe le prove sono superate.",
            },
            {
              type: 'paragraph',
              text: 'In caso di esito negativo, potrai ripetere la/e sola/e prova/e fallita/e in una successiva sessione d’esame. Le prove superate nella prima sessione rimangono valide per 12 mesi. Trascorso tale termine il candidato è tenuto a ripetere l’intero esame.',
            },
            {
              type: 'paragraph',
              text: "A superamento dell’esame, è previsto il rilascio del certificato con 3 anni di validità e l'iscrizione del professionista nel Registro di TÜV Italia.",
            },
            {
              type: 'paragraph',
              text: 'Per maggiori dettagli o dubbi riguardanti l’esame di certificazione, puoi metterti in contatto con tuv.esami@tuvsud.com',
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'it-sustainability-faq-7',
          question: 'Qual è la durata della certificazione e quali sono i requisiti per il suo mantenimento?',
          answer_blocks: [
            {
              type: 'paragraph',
              text: 'Il ciclo di certificazione prevede due mantenimenti annuali e, a scadenza dei tre anni, il rinnovo della certificazione.',
            },
            {
              type: 'paragraph',
              text: 'Per il mantenimento annuale e rinnovo della certificazione dovrai dimostrare di:',
            },
            {
              type: 'list',
              items: [
                'Aver svolto 20 ore aggiornamento professionale',
                'Avere esercitato la professione con continuità',
                'Non aver avuto provvedimenti sanzionatori da parte di associazioni di appartenenza o dal MISE',
                'Aver gestito correttamente eventuali reclami/ricorsi',
              ],
            },
            {
              type: 'paragraph',
              text: 'Per maggiori dettagli o dubbi riguardanti la durata della certificazione e il mantenimento, puoi metterti in contatto con tuv.esami@tuvsud.com',
            },
          ],
          component: 'faq_item',
        },
      ],
      title: 'Domande frequenti',
      eyebrow: 'FAQ',
      variant: 'lead',
      component: 'faq_section',
      bottom_text: 'Hai ancora domande? Le nostre esperte sono felici di supportarti!',
      description: 'Risposte alle domande più importanti su percorso, accesso, esame e certificazione.',
      whatsapp_url: {
        id: '',
        url: 'https://wa.me/390512987411?text=Ciao%2C%20vorrei%20maggiori%20informazioni%20sulla%20Masterclass%20Sustainability',
        target: '_blank',
        linktype: 'url',
        fieldtype: 'multilink',
        cached_url:
          'https://wa.me/390512987411?text=Ciao%2C%20vorrei%20maggiori%20informazioni%20sulla%20Masterclass%20Sustainability',
      },
      contact_title: 'Parla con le esperte',
      accordion_label: 'Domande frequenti',
      advisor_cta_label: 'Parla con le esperte',
      whatsapp_cta_label: 'Chatta su WhatsApp',
      contact_description: 'Hai ancora domande? Le nostre esperte sono felici di supportarti!',
    },
    {
      _uid: 'it-sustainability-footer',
      variant: 'lead',
      component: 'footer_section',
      about_text:
        'TÜV SÜD è leader mondiale nel settore dei servizi tecnici e vanta oltre 160 anni di competenza settoriale. TÜV Italia Akademie propone servizi di formazione e certificazione di persone, riconosciuti a livello globale.',
      legal_links: [
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/it-it/informativa-privacy',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/it-it/informativa-privacy',
          },
          _uid: 'it-sustainability-legal-1',
          label: 'Informativa Privacy',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/it-it/terms-and-conditions',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/it-it/terms-and-conditions',
          },
          _uid: 'it-sustainability-legal-2',
          label: 'Termini e Condizioni',
          component: 'link_item',
        },
      ],
      quick_links: [
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/it-it',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/it-it',
          },
          _uid: 'it-sustainability-link-1',
          label: 'TÜV SÜD Italia',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/it-it/store/italia',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/it-it/store/italia',
          },
          _uid: 'it-sustainability-link-2',
          label: 'Akademie Store',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/it-it/store/italia/catalogo-formativo/responsabilita-sociale-di-impresa-csr-sostenibilita-it',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url:
              'https://www.tuvsud.com/it-it/store/italia/catalogo-formativo/responsabilita-sociale-di-impresa-csr-sostenibilita-it',
          },
          _uid: 'it-sustainability-link-3',
          label: 'Corsi CSR & Sostenibilità',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/it-it/store/italia/catalogo-formativo/ambiente-it',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/it-it/store/italia/catalogo-formativo/ambiente-it',
          },
          _uid: 'it-sustainability-link-4',
          label: 'Corsi Ambiente',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/it-it/store/italia/catalogo-formativo/governance-risk-compliance-it',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/it-it/store/italia/catalogo-formativo/governance-risk-compliance-it',
          },
          _uid: 'it-sustainability-link-5',
          label: 'Corsi Governance',
          component: 'link_item',
        },
      ],
      social_links: [
        {
          url: {
            id: '',
            url: 'https://www.linkedin.com/showcase/tuvsud-training/',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.linkedin.com/showcase/tuvsud-training/',
          },
          _uid: 'it-sustainability-social-1',
          label: 'LinkedIn',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.youtube.com/playlist?list=PL25ZBDnHOGDjK3LGEN3rlIGTgqIxmupmL',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.youtube.com/playlist?list=PL25ZBDnHOGDjK3LGEN3rlIGTgqIxmupmL',
          },
          _uid: 'it-sustainability-social-2',
          label: 'YouTube',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.instagram.com/tuvsud/',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.instagram.com/tuvsud/',
          },
          _uid: 'it-sustainability-social-3',
          label: 'Instagram',
          component: 'link_item',
        },
      ],
      contact_email: 'tuv.formazione@tuvsud.com',
      contact_phone: '+39 051 298 7411',
      copyright_text: '© 2026 TÜV SÜD. Tutti i diritti riservati.',
      contact_address: 'TÜV Italia SRL\nViale Fulvio Testi 280/6 - 20126 Milano',
      primary_column_label: 'Link utili',
      secondary_column_label: 'Contatti Italia',
    },
    {
      _uid: 'it-sustainability-sticky',
      title: 'Masterclass per Sustainability Managers e Practitioners',
      subtitle: 'Nuova Edizione Disponibile',
      component: 'sticky_cta_bar',
      cta_label: 'Richiedi informazioni',
    },
    {
      _uid: 'it-sustainability-whatsapp',
      enabled: true,
      qr_hint: 'Oppure scansiona con il telefono',
      component: 'whatsapp_widget',
      nudge_text: 'Hai bisogno di supporto? Chatta con noi.',
      header_title: 'TÜV Italia Akademie',
      bubble_line_1: 'Ciao! Vuoi maggiori informazioni sulla Masterclass Sustainability?',
      bubble_line_2: 'Scrivici per dettagli su programma, calendari, certificazione e iscrizione.',
      open_cta_label: 'Chatta su WhatsApp',
      header_subtitle: 'Team formazione',
      reply_time_text: 'Rispondiamo appena possibile',
      whatsapp_number: '390512987411',
      prefilled_message:
        'Ciao, vorrei maggiori informazioni sulla Masterclass per Sustainability Managers e Practitioners.',
    },
  ],
} satisfies StaticLandingPage;
